import { render } from "./orderTypeActifityType.vue?vue&type=template&id=5ffcd000&scoped=true"
import script from "./orderTypeActifityType.vue?vue&type=script&lang=js"
export * from "./orderTypeActifityType.vue?vue&type=script&lang=js"

import "./orderTypeActifityType.vue?vue&type=style&index=0&id=5ffcd000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffcd000"]])

export default __exports__